import React from "react";
import { BiPlusCircle } from "react-icons/bi";
import { IoPulseOutline } from "react-icons/io5";

const MyGoalCard = ({ title , children,action,handleClick}) => {
  return (
    <>
      <div className="card rounded-1">
        <div className="cart-header border d-flex justify-content-between align-items-center py-3 px-3 border-bottom border-0">
          <h4
            style={{ fontSize: "19px" }}
            className="fw-bold  mb-0 pb-0 "
          >
            {title}
          </h4>
          <div onClick={handleClick} className="btn d-flex justify-content-center column-gap-1 align-content-center btn-outline-success">
            <i><BiPlusCircle size={15}/></i>
            {action}
          </div>
        </div>
        <div className="cart-body p-3">
          {children}
        </div>
      </div>
    </>
  );
};

export default MyGoalCard;
